import { DateTime } from 'luxon'
import React from 'react'
import { Note } from '@citruscamps/citrus-client'
import { Tooltip } from '../../../../../components/Tooltip/Tooltip'
import { formatFullName } from '../../../../../utils/formatters'
import { markdownToHtml } from '../../../../../utils/markdown'

interface IProps {
  note: Note
  hideDate?: boolean
}

export const NoteRow = ({ note, hideDate }: IProps) => {
  return (
    <>
      <div
        dangerouslySetInnerHTML={{
          __html: markdownToHtml(
            note.mentions.reduce(
              (text, mention) =>
                text.split(`[${mention.id}]`).join(`**${formatFullName(mention)}**`),
              note.text,
            ),
            {
              allowedTags: ['b', 'i', 'strong'],
            },
          ),
        }}
      ></div>

      <div className="small text-body-secondary">
        {formatFullName(note.created_by)}
        {!hideDate && (
          <Tooltip
            title={DateTime.fromJSDate(new Date(note.updated || note.created)).toLocaleString(
              DateTime.DATE_FULL,
            )}
            placement="right"
            popupProps={{ style: { zIndex: 1090 } }}
          >
            <div className="d-inline me-2">
              {' '}
              - {DateTime.fromJSDate(new Date(note.updated || note.created)).toRelative()}
            </div>
          </Tooltip>
        )}
      </div>
    </>
  )
}
